import { useContext } from "react";
import DataTableColumnSizingContext from "../components/DataTableColumnSizingContext";

const useTableColumnSizing = () => {
  const context = useContext(DataTableColumnSizingContext);
  if (!context) {
    throw new Error(
      "useTableColumnSizing must be used within a DataTableColumnSizingContext",
    );
  }
  return context;
};

export default useTableColumnSizing;
